import React, { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { STORAGE_KEY_LANG, STORAGE_KEY_LANG_MANUAL } from "../../../i18n/i18n";
import "../../../styles/auth.css";

const LANGUAGES = [
  { code: "en", label: "English" },
  { code: "fr", label: "Fran\u00e7ais" },
];

const LanguageToggle = () => {
  const { i18n } = useTranslation();
  const currentLang = i18n.language?.startsWith("fr") ? "fr" : "en";
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const selectLanguage = (code) => {
    if (code !== currentLang) {
      localStorage.setItem(STORAGE_KEY_LANG, code);
      localStorage.setItem(STORAGE_KEY_LANG_MANUAL, "1");
      i18n.changeLanguage(code);
    }
    setOpen(false);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const currentLabel = LANGUAGES.find((l) => l.code === currentLang)?.label;

  return (
    <div className="lang-toggle" ref={ref}>
      <button
        type="button"
        className="lang-toggle-btn"
        onClick={() => setOpen((prev) => !prev)}
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        {/* Globe icon */}
        <svg
          className="lang-toggle-icon"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="12" cy="12" r="10" />
          <path d="M2 12h20" />
          <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10A15.3 15.3 0 0 1 12 2z" />
        </svg>
        <span className="lang-toggle-label">{currentLabel}</span>
        {/* Chevron */}
        <svg
          className={`lang-toggle-chevron ${open ? "lang-toggle-chevron-open" : ""}`}
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fillRule="evenodd"
            d="M5.23 7.21a.75.75 0 0 1 1.06.02L10 11.168l3.71-3.938a.75.75 0 1 1 1.08 1.04l-4.25 4.5a.75.75 0 0 1-1.08 0l-4.25-4.5a.75.75 0 0 1 .02-1.06z"
            clipRule="evenodd"
          />
        </svg>
      </button>

      {open && (
        <ul className="lang-toggle-menu" role="listbox">
          {LANGUAGES.map((lang) => (
            <li
              key={lang.code}
              role="option"
              aria-selected={lang.code === currentLang}
              className={`lang-toggle-option ${lang.code === currentLang ? "lang-toggle-option-active" : ""}`}
              onClick={() => selectLanguage(lang.code)}
            >
              {lang.label}
              {lang.code === currentLang && (
                <svg className="lang-toggle-check" viewBox="0 0 20 20" fill="currentColor">
                  <path
                    fillRule="evenodd"
                    d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143z"
                    clipRule="evenodd"
                  />
                </svg>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default LanguageToggle;
